import Chart from "react-apexcharts";

const DoughnutChart = (props) => {
    const { series, options } = props;

    return (
        <Chart
            options={options}
            series={series}
            type="donut"
            width="100%"
            height="100%"
        />
    );
};

export default DoughnutChart;